import React from "react";

/** Placeholder of a TemplateRow while the list loads, at the same height. */
const TemplateRowSkeleton = () => (
    <div className="flex items-center gap-4 border-b border-gray-100 px-5 py-3.5 last:border-b-0" aria-hidden="true">
        <div className="corner-smooth-8 h-10 w-10 shrink-0 bg-gray-100 animate-pulse" />
        <div className="flex flex-1 flex-col gap-1.5">
            <div className="h-4 w-1/3 rounded bg-gray-100 animate-pulse" />
            <div className="h-3 w-1/4 rounded bg-gray-100 animate-pulse" />
        </div>
        <div className="hidden h-3 w-[160px] rounded bg-gray-100 animate-pulse ls:block" />
        <div className="flex w-[200px] flex-col gap-1.5">
            <div className="h-4 w-16 rounded bg-gray-100 animate-pulse" />
            <div className="h-3 w-24 rounded bg-gray-100 animate-pulse" />
        </div>
        <div className="w-[160px]" />
        <div className="h-5 w-5 rounded bg-gray-100 animate-pulse" />
    </div>
);

export default TemplateRowSkeleton;
